import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGridPlus = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M18.5 3L18.5 9",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M21.5 6H15.5",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.5 17.5C3.5 14.7778 4.27814 14 7.00018 14C9.72222 14 10.5 14.7778 10.5 17.5C10.5 20.2222 9.69231 21 7.00018 21C4.30805 21 3.5 20.2222 3.5 17.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M14.5 17.5C14.5 14.7778 15.2781 14 18.0002 14C20.7222 14 21.5 14.7778 21.5 17.5C21.5 20.2222 20.6923 21 18.0002 21C15.3081 21 14.5 20.2222 14.5 17.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M3.5 6.5C3.5 3.77778 4.27814 3 7.00018 3C9.72222 3 10.5 3.77778 10.5 6.5C10.5 9.22222 9.69231 10 7.00018 10C4.30805 10 3.5 9.22222 3.5 6.5Z",
			stroke: "#8A94A6",
			strokeWidth: 1.6,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
const ForwardRef = forwardRef(SvgGridPlus);
export { ForwardRef as ReactComponent };
